export default {
	tokens: {
		columns: {
			created: "Created",
			expires: "Expires",
			lastUsed: "Last used",
			revokedAt: "Revoked",
			permissions: "Permissions",
		},
		never: "Never",
		permissionCount: "{count} permission | {count} permissions",
		layerCount: "{count} space | {count} spaces",
		grantCount: "{count} | {count}",
		layerKind: { project: "Project", dataspace: "Dataspace" },
		state: {
			active: "Active",
			suspended: "Suspended",
			expired: "Expired",
			revoked: "Revoked",
			deleted: "Deleted",
		},
		revokedBy: {
			admin: "by an admin",
			client: "at the provider",
		},
		truncated: "The list is cut off at the provider's limit, so some tokens are not shown.",
		actions: {
			revoke: "Revoke",
			copy: "Copy",
			done: "Done",
		},
		create: {
			name: "Name",
			nameHint: "1–{max} characters, for example the script or job that will use it.",
			expires: "Expires",
			neverExpires: "Never expires",
			summary: "{permissions} on {layers}",
			noGrantable: "There are no projects or dataspaces you can grant permissions on.",
		},
		tree: {
			label: "Projects and dataspaces",
			filter: "Filter projects and dataspaces",
			noMatch: "Nothing matches.",
			selectEverything: "Select everything",
			selectAllIn: "Select all in {name}",
			unnamedProject: "Unnamed project",
			projectLevel: "Project level",
			expand: "Expand {name}",
			collapse: "Collapse {name}",
			count: "{ticked}/{total}",
		},
		pane: {
			selectAll: "Select all {count} permissions",
			readRequired: "Required by another permission here",
			groupCount: "{ticked}/{total} selected",
			noLayer: "Select a project or dataspace to choose its permissions.",
		},
		validation: {
			nameRequired: "Enter a name.",
			nameTooLong: "The name can be at most {max} characters.",
			permissionRequired: "Select at least one permission.",
			permissionsTooMany: "A token can hold at most {max} permissions; {count} are selected.",
			expiryRange: "Choose a date and time within the next {days} days.",
		},
		secret: {
			title: "Your new token",
			warning:
				"This secret is shown only once, so copy it now. A lost secret means creating a new token.",
			copied: "Copied.",
			copyFailed: "Copying failed. Select the secret and copy it by hand.",
		},
	},
};
